module.exports = __webpack_public_path__ + "static/img/shop.477060b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/shop.png
// module id = SawW
// module chunks = 0